import apiClient from 'apiClient';

export const assignCommission = (firmId: string, commissionTermId: string): Promise<void> => {
  return apiClient.post(`/api/v1/broker-management/commission-term/${commissionTermId}/assign/firm/${firmId}`);
};

export const unassignCommission = (firmId: string, commissionTermId: string): Promise<void> => {
  return apiClient.post(`/api/v1/broker-management/commission-term/${commissionTermId}/unassign/firm/${firmId}`);
};
